import { FC } from 'react'
import { Box } from '@mui/material'
import PageHeading from 'components/atoms/PageHeading'
import { useTranslation } from 'react-i18next'
import ProgramsSetupForm from 'components/organisms/forms/ProgramsSetupForm'

const ProgramsSetupPage: FC<{}> = () => {

  const { t } = useTranslation()

  return (
    <Box px={2}>
      <PageHeading title={t('common.personalized-learning-pathways')} />
      <Box sx={{padding: '30px'}} mb={3}><ProgramsSetupForm /></Box>
    </Box>
  )
}
export default ProgramsSetupPage
